import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import messages from './messages'
import thumbor from './components/thumbor'
import vueHeadful from 'vue-headful';
import VueLazyload from 'vue-lazyload';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios'

library.add(faFacebook)
library.add(faInstagram)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-headful', vueHeadful)
Vue.component('thumbor', thumbor)
Vue.use(VueLazyload)
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$vueThumbor = { options : {
  rootUrl : 'https://images.namelivia.com'
 }
}

const i18n = new VueI18n({
  locale: 'es', // set locale
  fallbackLocale: 'es', // set fallback locale 
  messages, // set locale messages
});

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  if (!language || !['es', 'en', 'fr'].includes(language)) {
	return router.push({ name: 'home', params: {lang: 'es'} });
  }
  i18n.locale = language
  next();
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

